import { render, staticRenderFns } from "./StatisticsDetailLayout.vue?vue&type=template&id=e73f6f60"
import script from "./StatisticsDetailLayout.vue?vue&type=script&lang=js"
export * from "./StatisticsDetailLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports